import React from "react";
import _Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import {makeStyles} from "@material-ui/core/styles";
import {Typography, Card} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import clsx from "clsx";
export class Loading extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let {message} = this.props;
    return (
      <div className="row no-gutters">
        <Alert className="alert-addon-card bg-info text-white shadow-lg mb-0">
          <span className="icon-addon alert-addon">
            <CircularProgress color="inherit" size={30} thickness={4} />
          </span>
          <span className="d-inline-block" style={{fontSize: "1rem"}}>
            {message}
          </span>
        </Alert>
      </div>
    );
  }
}

export class _LoadingSlim extends React.Component {
  constructor(props) {
    super(props);
  }

  getConfig() {
    let {size} = this.props;
    switch (size) {
      case "sm":
        return {circularSize: 40, fontSize: "c-text-s2"};
      case "xs":
        return {circularSize: 20, fontSize: "c-text-s1"};
    }
  }

  render() {
    let {message, className, align} = this.props;
    let config = this.getConfig();
    return (
      <div
        className={`d-flex flex-row justify-content-${align} align-items-center ${className}`}
      >
        <div
          className={`d-flex flex-column justify-content-center align-items-center`}
        >
          <CircularProgress
            color="secondary"
            size={config.circularSize}
            thickness={3}
          />
        </div>
        {message ? (
          <p className={`mb-0 ${config.fontSize} c-text-deep-grey ml-3`}>
            {message}
          </p>
        ) : null}
      </div>
    );
  }
}

_LoadingSlim.defaultProps = {
  message: "加载中",
  size: "sm",
  className: "",
  align: "center"
};

export const LoadingSlim = ({message, className, align, size,color,messageClassName}) => {
  const getConfig = () => {
    size = size || "sm";
    switch (size) {
      case "sm":
        return {
          circularSize: 40,
          fontSize: {
            fontSize: "0.98rem !important",
            lineHeight: "1.96rem !important"
          }
        };
      case "xs":
        return {
          circularSize: 20,
          fontSize: {
            fontSize: "0.875rem !important",
            lineHeight: "1.75rem !important"
          }
        };
    }
  };

  const config = getConfig();
  const useStyles = makeStyles(props => ({
    main: {
      display: "flex !important",
      flexDirection: "row !important",
      alignItems: "center !important",
      justifyContent: align || "center"
    },
    boby: {
      display: "flex !important",
      flexDirection: "column !important",
      alignItems: "center !important",
      justifyContent: "center !important"
    },
    message: {
      marginBottom: "0 !important",
      color: "#707070",
      marginLeft: "1rem !important",
      ...config.fontSize
    }
  }));

  let classes = useStyles();
  return (
    <div className={clsx(classes.main, className)}>
      <div className={classes.boby}>
        <CircularProgress
          color={color||"secondary"}
          size={config.circularSize}
          thickness={3}
        />
      </div>
      {message ? <p className={clsx(classes.message,messageClassName)}>{message}</p> : null}
    </div>
  );
};

//阿宝 未测试
export class Backdrop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    this.count = 0;
    Backdrop.current = this;
  }

  show(msg) {
    ++this.count;
    if (this.count === 1) {
      this.setState({open: true, message: msg || "请稍候"});
    }

    // if (this.count === 0) {
    //     this.setState({ open: true, message: msg || "请稍候" });
    //     return;
    // }
    // this.count++;
  }

  hide() {
    --this.count;
    if (this.count <= 0) {
      this.setState({open: false});
      return;
    }
    if (this.count < 0) this.count = 0;

    // if (this.count === 0) {
    //     this.setState({ open: false });
    //     return;
    // }
    // this.count--;
    // if (this.count < 0) this.count = 0;
  }

  render() {
    let {open, message} = this.state;
    let {style} = this.props;
    return (
      <_Backdrop
        style={{zIndex: 99999, backgroundColor: "rgba(0, 0, 0, 0)", ...style}}
        open={open}
      >
        <Loading message={message} />
      </_Backdrop>
    );
  }
}
